import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { ProjectState } from './ProjectState'
import { Music } from '../Util/Music/Music'

export const useProjectStore = create<ProjectState>()(
  persist((setter) => new ProjectState(setter),{ name: 'ProjectState' })
)
export function useIsMobile(){
  const isMobile:boolean = useProjectStore((state:ProjectState)=>{
    return state.isMobile
  }) 
  return isMobile  
}
export function useIsLoggedIn(){
  const isLoggedIn:boolean = useProjectStore((state:ProjectState)=>{
    return(state.isLoggedIn === true)
  }) 
  return isLoggedIn  
}
export function useValidation(){
    const val:string = useProjectStore((state:ProjectState)=>{
    return(state.validation)
  }) 
  return val
}

export function useAlphabet(){
  const alphabetType:number = useProjectStore((state:ProjectState)=>{
    return state.alphabetType
  }) 
  return Music.noteLabels[alphabetType]
}
export function useAlphabetType(){
    const alphabetType:number = useProjectStore((state:ProjectState)=>{
      return state.alphabetType
    }) 
    return alphabetType
}
export function useNoteName(noteIndex:number){
  const notes:string[] = useAlphabet()
  return notes[noteIndex]
}
export function useNoteNames(){
  const notes:string[] = useAlphabet()
  return notes
}